import { useState } from 'react'
import { useToast } from '../../hooks/toast'
import { useHistory } from 'react-router'
import usuarios from '../../api/usuarios'
import defaultOptions from '../../api/defaultoption'
import * as Yup from 'yup'
import ReCAPTCHA from 'react-google-recaptcha'
import * as auth from '../../api/auth/auth'
import TextField from '../TextField'
import Loader from '../Loader'
import { FormGroup, FormGroupIcon } from '../Form/styles'
import * as S from './styles'
import { HiX } from 'react-icons/hi'
import jwt from 'jsonwebtoken'
import { handleAlterarEmail } from './fetch'

const FormChangeEmail = ({ type, setShowModal }) => {
  const { addToast } = useToast()
  // const router = useHistory()

  const [values, setValues] = useState({
    email: '',
    newEmail: '',
    password: ''
  })

  const [passView, setPassView] = useState(true)
  const [loading, setLoading] = useState(false)
  const [inputErrors, setInputErrors] = useState(false)
  const [display, setDisplay] = useState('block')

  const [captcha, setCaptcha] = useState({
    value: '',
    expired: false
  })

  const token = auth.getToken()
  const tokenDecoded = jwt.decode(token)

  const onCaptchaChange = (value) => {
    // console.log('Captcha:', value)

    if (value === null) {
      setCaptcha({
        value: value,
        expired: true
      })
    } else {
      setCaptcha({ value: value, expired: false })
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setValues({
      ...values,
      [name]: value
    })

    setInputErrors({
      ...inputErrors,
      [name]: ''
    })
  }

  const logout = () => {
    auth.logout()

    return (window.location.href = `${process.env.REACT_APP_URL_MAIN}/MarketPlaceCliente/logout`)
  }

  const formData = {
    password: values.password,
    email: values.email,
    newEmail: values.newEmail,
    id: +tokenDecoded.id
  }

  const passSchema = Yup.object().shape({
    email: Yup.string()
      .email(
        'E-mail atual inválido',
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      .required('Campo obrigatório*'),
    newEmail: Yup.string()
      .notOneOf([Yup.ref('email')], 'Novo e-mail deve ser diferente do atual')
      .email(
        'Novo e-mail inválido',
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      .required('Campo obrigatório*'),
    password: Yup.string().required('Campo obrigatório*')
  })

  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)

    try {
      await passSchema.validate(formData, {
        abortEarly: false
      })

      if (captcha.value === '') {
        addToast({
          type: 'error',
          title: 'Por favor, complete a verificação "Não sou um Robô"'
        })
        setLoading(false)
      } else if (captcha.expired === true) {
        addToast({
          type: 'error',
          title:
            'Verificação expirada. Por favor, marque novamente a caixa de seleção'
        })
        setLoading(false)
      } else {
        //console.log(formData)
        let res = await handleAlterarEmail(formData, token)

        if (res?.includes('sucesso')) {
          addToast({
            type: 'success',
            title: 'Seu e-mail foi alterado com sucesso!',
            description:
              'Sua sessão será encerrada e você será redirecionado para a Home',
            timer: 5000
          })

          setTimeout(() => {
            logout()
          }, 3000)

          setLoading(false)
          setShowModal((prev) => !prev)
        } else {
          addToast({ type: 'error', title: `${res}` })

          setLoading(false)
        }
      }
    } catch (err) {
      if (err) setLoading(false)

      if (err instanceof Yup.ValidationError) {
        const emptyField = Object.values(err.value).every(
          (value) => value !== ''
        )

        if (!emptyField) {
          addToast({
            type: 'error',
            title: 'Todos os campos devem ser preenchidos'
          })

          const errorArray = err.inner.map(({ path, message }) => {
            return {
              name: path,
              message: message
            }
          })

          const objeto = errorArray.reduce((acc, d) => {
            // acc[d.name] = d.message
            acc[d.name] = d.message

            return acc
          }, {})

          setInputErrors(objeto)
        } else {
          setLoading(false)
          err.inner.map((error) => {
            addToast({
              type: 'error',
              title: `${error.message}`
            })
          })
        }
      }
    }
  }

  return (
    <S.WrapperSmall>
      <S.RegisterCard type={type}>
        <S.Title>Alterar E-mail</S.Title>
        {loading ? (
          <Loader
            style={{ position: 'fixed', top: '50%', left: '50%' }}
          ></Loader>
        ) : null}
        <p>
          Por favor, preencha os campos abaixo para alterar sua email de acesso.
        </p>
        <form action="" onSubmit={handleSubmit}>
          <FormGroup className="form-group required">
            <label htmlFor="email">Digite seu e-mail atual</label>
            <FormGroupIcon className="form-group-icon">
              <TextField
                maxlength={80}
                name="email"
                type="text"
                value={values.email}
                placeholder="E-mail atual"
                onChange={handleChange}
                error={inputErrors.email}
                autoFocus
              />
            </FormGroupIcon>
          </FormGroup>

          <FormGroup className="form-group required">
            <label htmlFor="email">Digite seu novo e-mail</label>
            <FormGroupIcon className="form-group-icon">
              <TextField
                maxlength={80}
                name="newEmail"
                type="text"
                value={values.newEmail}
                placeholder="E-mail novo"
                onChange={handleChange}
                error={inputErrors.newEmail}
              />
            </FormGroupIcon>
          </FormGroup>

          <FormGroup className="form-group required">
            <label htmlFor="email">Digite sua senha</label>

            <FormGroupIcon className="form-group-icon">
              <TextField
                maxlength={80}
                name="password"
                type={passView ? 'password' : 'text'}
                value={values.password}
                placeholder="Digite sua senha"
                onChange={handleChange}
                error={inputErrors.password}
              />
              {inputErrors.password ? (
                <span
                  className={!passView ? 'icon icon-eye' : 'icon icon-eye-cut'}
                  style={{ marginRight: 24 }}
                  onClick={() => setPassView(!passView)}
                ></span>
              ) : (
                <span
                  className={!passView ? 'icon icon-eye' : 'icon icon-eye-cut'}
                  onClick={() => setPassView(!passView)}
                ></span>
              )}
            </FormGroupIcon>
          </FormGroup>
          <S.CaptchaContainer>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_CAPTCHA_SITEKEY}
              onChange={onCaptchaChange}
            ></ReCAPTCHA>
          </S.CaptchaContainer>
          <S.ChangeButton type="submit">Alterar E-mail</S.ChangeButton>
        </form>
        {/* <div className="alert alert-info" style={{ display: display }}>
          <strong>Dica de Senha Segura: </strong>
          Combine letras e números e não utilize informações pessoais.
          <HiX
            onClick={() => {
              setDisplay('none')
            }}
          ></HiX>
        </div> */}
      </S.RegisterCard>
    </S.WrapperSmall>
  )
}

export default FormChangeEmail
